module.exports = __webpack_public_path__ + "img/p02.dcc53080.jpg";